import { TAccreditationBank } from '../../../types/accreditationBanks';
import domrf from './domrf.svg';
import rshb from './rshb.svg';
import sber from './sber.svg';

export const bankIcons: Record<TAccreditationBank, string> = {
  domrf,
  rshb,
  sber,
};
